'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var o, n, t = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(n = 0; n < i.length; n++)o = i[n], !(r.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (t[o] = e[o]);
    }
    return t;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var o, n, t = {}, i = Object.keys(e);
    for(n = 0; n < i.length; n++)o = i[n], r.indexOf(o) >= 0 || (t[o] = e[o]);
    return t;
}
const DoubleBanner = renderWithRef('DoubleBanner', null, (o, n)=>{
    let { children: t, hideFirstBannerBelowMedium: i, hideSecondBannerBelowMedium: l } = o, a = _object_without_properties(o, [
        "children",
        "hideFirstBannerBelowMedium",
        "hideSecondBannerBelowMedium"
    ]), s = new Set([
        'swan-double-banner'
    ]);
    return i && s.add('swan-double-banner-hide-first-banner-below-medium'), l && s.add('swan-double-banner-hide-second-banner-below-medium'), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: s,
        props: a,
        children: t
    });
});

export { DoubleBanner };
